import { makeEnvironmentHttpApiClient } from "@heydex/client-runtime/rpc";
import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";

import { primaryHttpBaseUrl } from "./target";

type PrimaryEnvironmentHttpApiClient = Effect.Success<
  ReturnType<typeof makeEnvironmentHttpApiClient>
>;

export interface PrimaryEnvironmentHttpClient {
  readonly PrimaryEnvironmentHttpClient: unique symbol;
}

export const PrimaryEnvironmentHttpClient: Context.Service<
  PrimaryEnvironmentHttpClient,
  PrimaryEnvironmentHttpApiClient
> = Context.Service("@heydex/web/environments/primary/httpClient/PrimaryEnvironmentHttpClient");

const make = Effect.suspend(() => makeEnvironmentHttpApiClient(primaryHttpBaseUrl()));

export const layer = Layer.effect(PrimaryEnvironmentHttpClient, make);
